import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { UsersService } from '../user/service/users.service';
import { SpNewUserComponent } from './components/sp-new-user/sp-new-user.component';
import { SPUserComponent } from './components/spUser/sp-user.component';
import { SPUserRoutingModule } from './sp-user-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, InputsModule, SPUserRoutingModule],
  providers: [UsersService],
  declarations: [SPUserComponent, SpNewUserComponent],
  exports: [SPUserComponent],
  entryComponents: [SPUserComponent]
})
export class SPUserModule {}
